import React, { useState } from "react";
import RejectForm from "./RejectForm";

export const FIELD_LABELS = {
  title: "Name", lat: "Latitude", lng: "Longitude", imo: "IMO", description: "Description", images: "Photos", image_meta: "Photo credits", photo_attribution: "Photo attribution",
  links: "Links", date: "Date", owner: "Owner", port_of_registry: "Port of registry", type: "Type",
  tonnage: "Tonnage", draught: "Draught", length: "Length", beam: "Beam", capacity: "Capacity", crew: "Crew", builder: "Builder",
};

export const showValue = (v) => {
  if (Array.isArray(v)) return v.length ? v.join("\n") : "(none)";
  if (v && typeof v === "object") {
    const rows = Object.entries(v).map(([url, m]) => `${url.replace(/^https?:\/\/(www\.)?/, "")}\n  ${m.credit || "no credit"} · ${m.license || "no licence"}`);
    return rows.length ? rows.join("\n") : "(none)";
  }
  if (v === undefined || v === null || v === "" || v === 0 || v === "unknown") return "(empty)";
  return String(v);
};

function EditCard({ e, onReview }) {
  const [rejecting, setRejecting] = useState(false);
  return (
    <div className="pending-ship-card">
      <h3>{e.ship_title}</h3>
      <p><strong>Suggested by:</strong> {e.submitted_by === "deleted" ? "deleted" : `@${e.submitted_by}`} · <a href={`/${e.ship_id}`} target="_blank" rel="noreferrer">ship #{e.ship_id}</a></p>
      {e.note && <p><strong>Reason:</strong> {e.note}</p>}
      <div className="diff-list">
        {Object.keys(e.changes).map((k) => (
          <div key={k} className="diff-row">
            <span className="diff-field">{FIELD_LABELS[k] || k}</span>
            <pre className="diff-old">{showValue(e.current[k])}</pre>
            <pre className="diff-new">{showValue(e.changes[k])}</pre>
          </div>
        ))}
      </div>
      {rejecting ? (
        <RejectForm what="this edit" onCancel={() => setRejecting(false)} onConfirm={(r) => onReview(e.id, "reject", r)} />
      ) : (
        <div className="edit-review-actions">
          <button className="approve" onClick={() => onReview(e.id, "approve")}>Approve</button>
          <button className="reject" onClick={() => setRejecting(true)}>Reject</button>
        </div>
      )}
    </div>
  );
}

export default function PendingEdits({ edits, onReview, hideTitle }) {
  if (!edits.length) return null;
  return (
    <div className="edit-review">
      {!hideTitle && <h3 className="edit-review-title">Suggested edits ({edits.length})</h3>}
      {edits.map((e) => <EditCard key={e.id} e={e} onReview={onReview} />)}
    </div>
  );
}
